import React from 'react';
import {
    SuperCropOneSvg,
    SuperCropThreeSvg,
    SuperCropTwoSvg,
} from './resources';

export const ORGANIZER_IMAGE_DIAMETER = '72px';
export const SUPER_CROPS = [
    <SuperCropOneSvg key="supercrop-one" />,
    <SuperCropTwoSvg key="supercrop-two" />,
    <SuperCropThreeSvg key="supercrop-three" />,
];
